import { Icon } from 'ol/style';
import StyleFactory from '../../StyleFactory';
import defaultTheme from '../defaultTheme';

const createPinIconByType = (type, theme) => {
  let iconSrc, anchor, iconScale;

  if (theme[type] && theme[type].iconSrc && theme[type].pinCorner) {
    iconSrc = theme[type].iconSrc;
    anchor = theme[type].pinCorner;
    iconScale = theme[type].iconScale || defaultTheme[type].iconScale;
  } else {
    iconSrc = defaultTheme[type].iconSrc;
    anchor = defaultTheme[type].pinCorner;
    iconScale = defaultTheme[type].iconScale;
  }

  return new Icon({
    scale: iconScale,
    src: iconSrc,
    anchor: anchor,
    anchorXUnits: 'pixels',
    anchorYUnits: 'pixels'
  });
};

const getPinIconByType = (type, theme) => {
  const key = theme[type] && theme[type].iconSrc;

  if (key && iconCache[key]) {
    return iconCache[key];
  }

  const icon = createPinIconByType(type, theme);
  iconCache[key] = icon;
  return icon;
};

let iconCache = {};
const portsPilotsStyle = StyleFactory.createStyle({
  image: (feature, resolution, params, viewOptions, theme) => {
    const type = feature.get('FeatureType');
    const icon = getPinIconByType(type, theme);
    return icon;
  }
});
const clusteredPinStyle = StyleFactory.createStyle({
  image: (feature, resolution, params, viewOptions, theme) => {
    const type = 'Clustered';
    const icon = getPinIconByType(type, theme);
    return icon;
  }
});
export default ((...args) => (clusteredFeatures, resolution, params) => {
  const features = clusteredFeatures.get('features');

  if (!features || features.length === 0) {
    return;
  }

  if (features.length === 1) {
    return portsPilotsStyle(...args)(features[0], resolution, params);
  } else {
    return clusteredPinStyle(...args)(clusteredFeatures, resolution, params);
  }
});